const LVUltrasound = () => (
	<>
		<path
			transform="scale(0.0333) translate(0, 960)"
			d="M280-240v-480h80v480h-80ZM440-80v-800h80v800h-80ZM120-400v-160h80v160h-80Zm480 160v-480h80v480h-80Zm160-160v-160h80v160h-80Z"
			fill="currentColor"
		/>
	</>
);

export default LVUltrasound;
